import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.concat.js";

/**
 * CSS 变量注入
 * @description 运行时将 ThemeTokens 映射为 :root 上的 CSS 自定义属性（--theme-* 前缀）
 */
import { getThemeTokens, resolveThemeName } from './theme-map';
var ROOT_VALUE = 100;
/**
 * 将令牌值中的 px 值换算为 rem（除以 rootValue 100），与 postcss-pxtorem 缩放体系对齐
 * @param value 令牌值（可含多个 px）
 * @returns 换算后的值
 */

export function pxToRem(value) {
  return value.replace(/(\d+(?:\.\d+)?)px/g, function (_, px) {
    return "".concat(parseFloat(px) / ROOT_VALUE, "rem");
  });
} // 令牌 → CSS 变量名映射

var themeVarNameMap = {
  colorSurface: '--theme-color-surface',
  colorTitle: '--theme-color-title',
  colorTextMain: '--theme-color-text-main',
  colorTextSecondary: '--theme-color-text-secondary',
  colorTextPlaceholder: '--theme-color-text-placeholder',
  colorTextWeak: '--theme-color-text-weak',
  colorTextDisabled: '--theme-color-text-disabled',
  colorTextAction: '--theme-color-text-action',
  colorBorder: '--theme-color-border',
  color_1: '--theme-color-1',
  color_2: '--theme-color-2',
  color_3: '--theme-color-3',
  color_4: '--theme-color-4',
  color_5: '--theme-color-5',
  color_6: '--theme-color-6',
  buttonTextColor: '--theme-button-text-color',
  buttonBackgroundColor: '--theme-button-background-color',
  buttonActiveBackgroundColor: '--theme-button-active-background-color',
  buttonBorderRadius: '--theme-button-border-radius',
  buttonBorder: '--theme-button-border',
  buttonBoxShadow: '--theme-button-box-shadow',
  buttonDisabledTextColor: '--theme-button-disabled-text-color',
  buttonDisabledBackgroundColor: '--theme-button-disabled-background-color',
  buttonDisabledBorder: '--theme-button-disabled-border',
  buttonSecondaryBackgroundColor: '--theme-button-secondary-background-color',
  buttonSecondaryText: '--theme-button-secondary-text',
  buttonSecondaryBorder: '--theme-button-secondary-border',
  buttonSecondaryBoxShadow: '--theme-button-secondary-box-shadow',
  buttonSecondaryActiveBackgroundColor: '--theme-button-secondary-active-background-color',
  buttonTertiaryBackgroundColor: '--theme-button-tertiary-background-color',
  buttonTertiaryText: '--theme-button-tertiary-text',
  buttonTertiaryActiveBackgroundColor: '--theme-button-tertiary-active-background-color',
  buttonTertiaryActiveText: '--theme-button-tertiary-active-text'
};
var STYLE_TITLE = 'dynamic-theme-sheet';
/**
 * 获取或创建名为 dynamic-theme-sheet 的样式表
 */

function getRootStyleSheet() {
  var existing = document.querySelector("style[title=\"".concat(STYLE_TITLE, "\"]"));

  if (existing && existing.sheet) {
    return existing.sheet;
  }

  var style = document.createElement('style');
  style.title = STYLE_TITLE;
  document.head.appendChild(style);
  return style.sheet;
}
/**
 * 根据 AppName 应用主题，将 ThemeTokens 注入为 :root CSS 自定义属性
 * @param appName 应用标识（可空，未注册时回退 jojo 默认主题）
 */


export function applyThemeByAppName(appName) {
  var themeName = resolveThemeName(appName);
  var tokens = getThemeTokens(appName);
  var sheet = getRootStyleSheet(); // 清除上一轮 :root 规则，保证幂等性

  if (sheet.cssRules) {
    for (var i = sheet.cssRules.length - 1; i >= 0; i -= 1) {
      var rule = sheet.cssRules[i];

      if (rule instanceof CSSStyleRule && rule.selectorText === ':root') {
        sheet.deleteRule(i);
      }
    }
  } // 生成 :root 规则


  var declarations = [];
  Object.keys(themeVarNameMap).forEach(function (key) {
    var value = tokens[key];

    if (value === null || value === undefined) {
      // 跳过空值令牌
      return;
    }

    declarations.push("".concat(themeVarNameMap[key], ": ").concat(pxToRem(value), ";"));
  });
  var rootRule = ":root { ".concat(declarations.join(' '), " }");
  sheet.insertRule(rootRule, 0);
  document.documentElement.dataset.themeName = themeName;
  document.documentElement.dataset.appName = appName || '';
}